export default "__VITE_ASSET__DLr2QW$J__"